export default __webpack_public_path__ + "assets/images/a759d46eb7ac37888f44811fa9af2fb7.png";